import * as React from 'react'
import clsx from 'clsx'

import CheckmarkIcon from 'assets/icons/checkmark.svg'

export interface ListboxProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactChild
  selected?: boolean
}
export const Listbox = React.forwardRef<HTMLDivElement, ListboxProps>(
  (props, ref) => {
    const { children, className, selected, onClick, ...ListboxProps } = props
    const classes = clsx(
      'focus:outline-none flex justify-between text-base py-4 rounded-md p-2',
      className,
      selected && 'font-semibold bg-surface-subdued'
    )

    function handlePress(e: React.KeyboardEvent<HTMLDivElement>) {
      if (e.key === 'Enter') {
        onClick(e as any)
        return
      }
    }

    return (
      <div
        tabIndex={0}
        className={classes}
        onKeyPress={handlePress}
        onClick={onClick}
        ref={ref}
        {...ListboxProps}
      >
        <div>{children}</div>
        {selected && <CheckmarkIcon style={{ minWidth: 20 }} />}
      </div>
    )
  }
)

Listbox.displayName = 'Listbox'
